import { Component } from '@angular/core';
import { UserService } from '../../user.service';
import { IUser, IUserTable, USER_TTL_ES } from '../../user.interface';
import { ROLE_ID } from 'src/app/auth/interfaces/role.interface';
import { CrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.template';
import { ICrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.interface';
import { IAmiHead } from 'src/app/@amiga-pyme/components/ami-head/ami-head.interface';

@Component({
  selector: 'pg-user',
  templateUrl: './user.component.html'
})
export class UserComponent extends CrudTemplate implements ICrudTemplate {
  constructor(private serviceBase: UserService) {
    super(USER_TTL_ES, serviceBase);
  }
  settingsAmiHead: IAmiHead = {
    title: USER_TTL_ES,
    addressImg: 'users'
  };
  ngOnInit() {
    this.table.settings = {
      title: USER_TTL_ES,
      columns: [
        { header: 'Nombre', field: 'names' },
        { header: 'Apellido', field: 'surnames' },
        { header: 'Usuario', field: 'username' },
        { header: 'Cargo', field: 'role' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IUser[]) => {
        this.parseToTable(data);
      });
  }

  parseToTable(dataService: IUser[]) {
    const dataTable: IUserTable[] = dataService.map((item) => {
      return {
        ...item,
        role: ROLE_ID[item.roleId]
      };
    });
    this.table.data = dataTable;
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
